import React from 'react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core';
import { MasterInit } from '../_metronic/layout/MasterInit';
import { AuthInit } from './modules/auth';
import '../global.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { RecoilRoot } from 'recoil';

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LayoutProvider>
        <AuthInit>
          <RecoilRoot>
            <Outlet />
            <MasterInit />
          </RecoilRoot>
        </AuthInit>
      </LayoutProvider>
      <ToastContainer />
    </Suspense>
  );
};

export { App };
